import { jsxs as e, Fragment as o, jsx as t } from "react/jsx-runtime";
import { useState as r, useEffect as i } from "react";
import { ErrorCode as s } from "react-dropzone";
import n from "../../assets/base-trash.svg.js";
import a from "@mui/icons-material/InsertDriveFile";
import { Stack as l } from "@mui/joy";
import { FileDropzone as c } from "./FileDropzone.js";
import { useCustomDropzone as m } from "./ImageUploader/hooks/useCustomDropzone.js";
import { isFileLikeObject as p } from "./ImageUploader/util/index.js";
import { ImageInfo as d } from "./ImageUploader/ImageInfo.js";
const g = (e2) => {
  const [o2] = e2;
  switch (o2 == null ? void 0 : o2.code) {
    case s.FileInvalidType:
      return "Невірний формат";
    case s.FileTooLarge:
      return "Файл завеликий";
    case s.TooManyFiles:
      return "Забагато файлів";
  }
  return "Невідома помилка";
}, u = ({ accept: s2, acceptLabel: u2, maxFiles: f, onChange: h, onRemoveFile: F }) => {
  const [v, I] = r([]), [j, x] = r([]);
  i(() => {
    h(v);
  }, [v]), i(() => {
    (j == null ? void 0 : j.length) > 0 && (F == null ? void 0 : F(j));
  }, [j, F]);
  const { removeFile: k, getRootProps: w, getInputProps: D, selectedFiles: b, rejectedFiles: R, removeRejectedFile: z } = m({ selectedFiles: v, setSelectedFiles: I, onRemoveFile: (e2) => {
    p(e2) && x([...j, e2]);
  }, accept: s2, maxFiles: f });
  return e(o, { children: [e(l, { gap: 5, children: [b.map((e2) => {
    return t(d, { isLoading: false, isSuccess: true, isInvalid: false, title: e2.name, file: e2, onDelete: k, description: e2.size ? (o2 = e2.size, (o2 / 1024).toFixed(0) + "kb") : null, icon: a, DeleteIconComponent: n });
    var o2;
  }), R.map((e2) => t(d, { isLoading: false, isSuccess: false, isInvalid: true, title: e2.file.name, file: e2, onDelete: z, icon: a, description: g(e2.errors), DeleteIconComponent: n }))] }), b.length < f && t(l, { gap: 2, flex: 3, sx: { backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23636B744D' stroke-width='2' stroke-dasharray='5%2c 9' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`, borderRadius: "8px", backgroundColor: "#fff" }, children: t(c, { accept: Object.values(s2).join(", "), getInputProps: D, getRootProps: w, title: u2 }) })] });
};
export {
  u as FileUpload
};
//# sourceMappingURL=FileUpload.js.map
